import { makeStyles } from '@material-ui/core/styles';

export default makeStyles((theme) => ({
  paper: {
    padding: theme.spacing(3),
    marginTop: theme.spacing(4),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  groupImage: {
    maxWidth: '100%',
    marginBottom: theme.spacing(2),
    borderRadius: theme.spacing(1),
  },
  missionTitle: {
    marginBottom: theme.spacing(2),
    fontWeight: 'bold',
  },
  missionText: {
    marginBottom: theme.spacing(2),
    fontSize: '18px',
  },
  mapLink: {
    marginTop: theme.spacing(2),
    textAlign: 'center',
  },
  linkText: {
    color: theme.palette.primary.main,
    textDecoration: 'none',
    fontWeight: 'bold',
  },
}));